import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Button from "@/components/base/Button";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-primary-950 flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full bg-secondary-500 blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full bg-accent-500 blur-3xl" />
      </div>
      <div className="relative text-center">
        <p className="text-accent-400 text-sm font-bold uppercase tracking-[0.3em]">Error 404</p>
        <h1 className="mt-4 font-heading text-7xl md:text-9xl font-semibold text-background-50">404</h1>
        <p className="mt-4 text-primary-100/85 text-lg">The page you&apos;re looking for couldn&apos;t be found.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Button to="/" variant="accent" size="lg">
            <Home className="w-5 h-5" /> Back to Home
          </Button>
          <Link to="/appointment" className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/30 px-8 py-4 text-base font-semibold text-background-50 hover:bg-background-50/10 transition-colors whitespace-nowrap">
            Book Appointment
          </Link>
        </div>
      </div>
    </div>
  );
}